import { render } from "./TeamGrid.vue?vue&type=template&id=3d6c8854&scoped=true"
import script from "./TeamGrid.vue?vue&type=script&lang=js"
export * from "./TeamGrid.vue?vue&type=script&lang=js"

import "./TeamGrid.vue?vue&type=style&index=0&id=3d6c8854&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6c8854"]])

export default __exports__